import script from "./printDokumenSIO.vue?vue&type=script&setup=true&lang=js"
export * from "./printDokumenSIO.vue?vue&type=script&setup=true&lang=js"

import "./printDokumenSIO.vue?vue&type=style&index=0&id=4c02a8a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c02a8a9"]])

export default __exports__